import { render, staticRenderFns } from "./CheckPending.vue?vue&type=template&id=5bdcd397&scoped=true"
import script from "./CheckPending.vue?vue&type=script&lang=js"
export * from "./CheckPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdcd397",
  null
  
)

export default component.exports